<!--
  功能：因子详情页
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2024-06-06 09:29:30
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div
    class="yz-bg"
    :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'"
    v-cloak
  >
    <!-- 头部信息  -->
    <div class="info-header">
      <navigation :text="'自定义因子详情'" :searchShow="true"></navigation>
    </div>
    <!-- 内容 -->
    <div class="info-content">
      <div class="content-top">
        <span
          class="tab-text"
          v-for="(text, indexT) in navList"
          :key="indexT"
          @click="clickTabToggle(text)"
          :class="selectNav == text.id ? 'tab-on' : ''"
        >
          {{ text.name }}
        </span>
      </div>
      <!-- 概述信息 - 信号池 -->
      <div class="content-bottom">
        <!-- 概述 -->
        <div class="content-overview" id="yzgs">
          <div class="overview-title">{{ factorData.yz_name }}</div>
          <div>
            <van-row gutter="20">
              <van-col span="12">
                <div class="overview-today">
                  <div class="overview-zf" :class="[judgeColor(hqData.RiZhangFu)]">
                    {{ toFixedNum(hqData.RiZhangFu * 100, 2, '%') }}
                  </div>
                  <div class="overview-text">日涨幅</div>
                </div>
              </van-col>
              <van-col span="12">
                <div class="overview-today">
                  <div class="overview-zf">{{ hqData.XinHaoShuLiang || '0' }}只</div>
                  <div class="overview-text">今日数量</div>
                </div>
              </van-col>
            </van-row>
          </div>
          <div class="overview-desc" v-show="factorData.factor_type == 2">
            {{ factorData.Description }}
          </div>
        </div>
        <!-- 信号池 -->
        <div class="content-stock" id="jrxh">
          <div class="stock-title">因子信号池</div>
          <div class="table_content">
            <table width="100%" cellspacing="0" cellpadding="0" v-if="xhList.length > 0">
              <tr class="table-title">
                <th>股票名称</th>
                <th
                  :class="[
                    xhfield === 'ZuiXinJia' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZuiXinJia' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZuiXinJia' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZuiXinJia')"
                >
                  最新
                </th>
                <th
                  :class="[
                    xhfield === 'ZhangFu' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZhangFu' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZhangFu' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZhangFu')"
                >
                  涨幅%
                </th>
                <th
                  :class="[
                    xhfield === 'ZhangDie' && xhdesc === true ? 'sort down' : '',
                    xhfield === 'ZhangDie' && xhdesc === false ? 'sort up' : '',
                    xhfield !== 'ZhangDie' ? 'sort' : ''
                  ]"
                  @click="sortFn('ZhangDie')"
                >
                  涨跌
                </th>
                <th>操作</th>
              </tr>
              <tr v-for="(item, index) in xhList" :key="index" @click="gogufs(item.Obj)">
                <td>
                  <p>{{ item.ZhongWenJianCheng }}</p>
                  <p>{{ item.JiaoYiDaiMa }}</p>
                </td>
                <td>{{ toFixedNum(item.ZuiXinJia, 2, '') }}</td>
                <td :class="[judgeColor(item.ZhangFu)]">{{ toFixedNum(item.ZhangFu, 2, '%') }}</td>
                <td>{{ toFixedNum(item.ZhangDie, 2, '') }}</td>
                <td>
                  <span
                    :class="item.joinShow ? 'active' : ''"
                    @click.stop="addStock(item, index)"
                    >{{ item.joinShow ? '已加入' : '加自选' }}</span
                  >
                </td>
              </tr>
            </table>
            <van-empty
              v-if="xhQuery && xhList.length <= 0"
              class="custom-image"
              :image="not_data"
              description="暂未获取到数据"
            />
            <div
              class="more_btn"
              @click="jrxhMore"
              v-show="xhQuery && xhList.length < xhObjCount && xhList.length > 0"
            >
              加载更多
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toFixedNum, judgeColor, formtTime,strToHexCharCode } from '@/utils/format';
import VueScrollTo from 'vue-scrollto';
import { getCustomFactorById } from '@/api/factor';
import {
  getDyzClById,
  getIncomeanalysis,
  getDyzHistory,
  getFactorHq,
  getObjSort,
  insertStockByGroup,
  getMyZxStockInfo,
  reportBrowse,
  addMyFavor,
  delMyFavor,
  setShareById
} from '@/api/index.js';
import mixin from '@/mixins/index.js';
export default {
  name: '',
  mixins: [mixin],
  data() {
    return {
      // 导航
      navList: [
        { name: '因子概述', id: 'yzgs' },
        { name: '因子信号池', id: 'jrxh' }
      ],
      selectNav: 'yzgs',
      // 股票查询类型
      xhfield: 'ZhangFu',
      // 股票查询顺序
      xhdesc: true,
      // 信号列表
      xhList: [],
      xhQuery: false,
      xhstart: 1,
      xhcount: 20,
      xhObjCount: 0,
      myStockList: [],
      xhF_id_arr: '',
      // 因子 ID
      fid: '',
      // 因子详情
      factorData: {},
      // 因子行情
      hqData: {},
      // 因子 16 进制
      fidInfo: ''
    };
  },
  filters: {},
  // 侦听器
  watch: {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    this.selectNav = this.navList[0].id;
    // 获取路由中的因子 ID
    this.fid = this.$route.query.fid;
    // 根据 ID 获取因子详情
    this.getCustomFactorByIdFun();
  },
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted: function () {},
  // 组件方法
  methods: {
    toFixedNum,
    judgeColor,
    formtTime,
    // 切换 tab
    clickTabToggle: function (item) {
      if (item.id == this.selectNav) {
        return false;
      }
      this.selectNav = item.id;
      this.scrollToSection(item.id);
    },
    scrollToSection(sectionId) {
      VueScrollTo.scrollTo(`#${sectionId}`, 500, {
        container: '.content-bottom',
        offset: 0 // 调整偏移量以适应您的布局
      });
    },
    // 根据 ID 查询自定义因子
    getCustomFactorByIdFun: function () {
      let params = {
        yz_id: this.fid
      };
      getCustomFactorById(params)
        .then((result) => {
          if (result.err == 200) {
            this.factorData = result.data;
            // this.xhF_id_arr = result.data.condition_info;

            var groupID = "";
            if (result.data.factor_type == 1) {
              groupID = ":" + strToHexCharCode(":&F" + strToHexCharCode(result.data.condition_info));
            } else if (result.data.factor_type == 2) {
              groupID = result.data.FactorIDs;
            } else if (result.data.factor_type == 3) {
              groupID = ":" + strToHexCharCode(":&" + result.data.FactorIDs);
            } else {
              groupID = ":" + strToHexCharCode(":&" + result.data.condition_info);
            }

            this.xhF_id_arr = groupID;

            this.getFactorHqFun(groupID);
            this.getMyOptional(groupID);
          } else {
            this.factorData = {};
          }
        })
        .catch((err) => {
          this.factorData = {};
        });
    },
    // 根据条件查询当日股池
    // 今日信号
    getXhData: function (id, addType) {
      let that = this;
      this.xhQuery = false;
      let obj = {
        factorid: id,
        field: that.xhfield,
        desc: that.xhdesc,
        start: that.xhstart,
        count: that.xhcount
      };
      getObjSort(obj)
        .then((res) => {
          if (res.err === 200 && res.data.list.length > 0) {
            that.xhObjCount = res.data.ObjCount;
            if (addType) {
              that.xhList = that.checkStock(res.data.list);
            } else {
              that.xhList = [...that.xhList, ...that.checkStock(res.data.list)];
            }
          }
          that.xhQuery = true;
        })
        .catch(() => {
          that.xhQuery = true;
        });
    },
    // 今日信号点击更多
    jrxhMore: function () {
      this.xhstart = this.xhstart + 20;
      this.getXhData(this.xhF_id_arr, false);
    },

    // 今日信号排序
    sortFn: function (type) {
      // this.
      if (this.xhfield === type) {
        this.xhdesc = !this.xhdesc;
      } else {
        this.xhfield = type;
        this.xhdesc = true;
      }
      this.xhstart = 1;
      // this.xhList = [];
      this.getXhData(this.xhF_id_arr, true);
    },

    // 加自选
    addStock: function (item, index) {
      if (item.joinShow) return;
      let obj = {
        stocks: item.Obj
      };
      insertStockByGroup(obj).then((res) => {
        if (res.err === 200) {
          let ste = this.xhList[index];
          this.$set(ste, 'joinShow', true);
          this.$toast('加入成功');
        } else {
          this.$toast('加入失败');
        }
      });
    },

    // 处理自选数据判断当前股票是否已加入自选
    checkStock: function (arr) {
      let that = this;
      let stocks = that.myStockList.toString();
      let newArr = arr.map((item) => {
        if (stocks.indexOf(item.Obj) !== -1) {
          item.joinShow = true;
        } else {
          item.joinShow = false;
        }
        return item;
      });
      return newArr;
    },
    // 获取我的自选股
    getMyOptional: function (f_id_arr) {
      let that = this;
      getMyZxStockInfo({})
        .then((res) => {
          if (res.err === 200) {
            that.myStockList = res.data.Stocks ? res.data.Stocks : [];
            that.$nextTick(function () {
              that.getXhData(f_id_arr, true);
            });
          } else {
            that.xhQuery = true;
          }
        })
        .catch(() => {
          that.xhQuery = true;
        });
    },
    // 根据条件查询行情
    getFactorHqFun: function (idKeys) {
      let obj = {
        type: 'cl',
        groupID: idKeys
        // field: 'Desc'
      };
      getFactorHq(obj).then((res) => {
        if (res.err === 200) {
          this.hqData = res.data[0];
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.yz-bg {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #f1f7fe;
  background-image: url('../../assets/image/zryy/factor-bg.png');
  background-position: top center;
  background-repeat: no-repeat;
  background-size: 100%; /* 背景图宽度自适应 */
  background-attachment: fixed;
  //  头部
  .info-header {
    margin-top: 44px;
  }

  // 内容
  .info-content {
    height: calc(100vh - 90px);
    overflow: hidden;
    overflow-y: auto;
    .content-top {
      width: 100%;
      height: 25px;
      // border: 1px solid red;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      padding: 0 16px;
      margin-bottom: 4px;
      .tab-text {
        color: #4e5969;
        font-size: 14px;
        margin-right: 16px;
      }
      .tab-on {
        color: #1d2129;
        font-size: 14px;
        font-weight: 500;
        position: relative;
      }
      .tab-on::before {
        content: '';
        width: 16px;
        height: 3px;
        display: block;
        background: #000;
        position: absolute;
        left: calc(50% - 8px);
        transform: translateX(-50%);
        bottom: -4px;
        -webkit-animation: scale-up-hor-center 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
        animation: scale-up-hor-center 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
      }

      @-webkit-keyframes scale-up-hor-center {
        0% {
          -webkit-transform: scaleX(0.4);
          transform: scaleX(0.4);
        }
        100% {
          -webkit-transform: scaleX(1);
          transform: scaleX(1);
        }
      }
      @keyframes scale-up-hor-center {
        0% {
          -webkit-transform: scaleX(0.4);
          transform: scaleX(0.4);
        }
        100% {
          -webkit-transform: scaleX(1);
          transform: scaleX(1);
        }
      }
    }
    // 内容主体
    .content-bottom {
      height: calc(100vh - 120px);
      overflow: hidden;
      overflow-y: auto;
      // 因子基本数据
      .content-overview {
        background: #ffffff;
        padding: 16px;
        border-radius: 8px 8px 0px 0px;
        margin-bottom: 8px;
        .overview-title {
          color: #1d2129;
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 12px;
        }
        .overview-today {
          height: 70px;
          background: #f7f8fa;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-content: center;
          justify-content: center;
          align-items: center;
          .overview-zf {
            font-family: 'dzh';
            font-weight: 500;
            // color: #4e5969;
            font-size: 18px;
          }
          .overview-text {
            color: #949da8;
            font-size: 12px;
            margin-top: 4px;
          }
        }
        .overview-desc {
          color: #949da8;
          font-size: 12px;
          margin-top: 12px;
        }
      }
      // 股池内容
      .content-stock {
        background: #ffffff;
        border-radius: 8px 8px 0px 0px;
        padding: 16px;
        // height: calc(100vh - 120px);
        // overflow: hidden;
        .stock-title {
          font-weight: 500;
          color: #1d2129;
          font-size: 16px;
        }
        .table_content {
          font-family: 'dzh';
          margin-bottom: 8px;
          // border: 1px solid red;
          // padding-bottom: 20px;
          .table-title {
            position: sticky;
            top: 0;
            background-color: #ffffff;
          }
          table {
            th {
              font-size: 12px;
              color: #999999;
              font-weight: 400;
              padding: 4px 0;

              &:first-child {
                // padding-left: 15px;
                box-sizing: border-box;
                text-align: left;
                width: 25%;
              }
              &:last-child {
                // padding-right: 15px;
                box-sizing: border-box;
                text-align: right;
                width: 20%;
              }
            }
            td {
              height: 57px;
              text-align: center;
              font-size: 14px;
              color: #555555;
              &:first-child {
                // padding-left: 15px;
                width: 25%;
                p {
                  text-align: left;
                  &:first-child {
                    color: #555555;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 20px;
                  }
                  &:last-child {
                    color: #999999;
                    font-size: 12px;
                    line-height: 17px;
                  }
                }
              }
              &:last-child {
                // padding-right: 17px;
                width: 20%;
                font-size: 11px;
                span {
                  padding: 2px 3px;
                  background-color: rgba(40, 109, 247, 0.06);
                  color: #286df7;
                  border-radius: 2px;
                  float: right;
                  &.active {
                    background-color: rgba(153, 153, 153, 0.0588235);
                    color: #999999;
                  }
                }
              }
            }
          }
          .more_btn {
            width: 343px;
            height: 33px;
            text-align: center;
            line-height: 33px;
            background: rgba(40, 109, 247, 0.06);
            border-radius: 4px;
            color: #286df7;
            font-size: 12px;
            margin: 0 auto;
          }
        }
      }
    }
  }
}

// 黑版
.black_theme {
  background-color: #0B0F12;
  background-image: url('../../assets/image/zryy/factor-bg-black.png');
  // 导航
  .navget_main {
    color: #ffffff;
  }
  .info-content {
    .content-top {
      .tab-text {
        color: #c9cbdc;
        a {
          color: #c9cbdc;
        }
      }
      .tab-on {
        a {
          color: #fff;
        }
      }
      .tab-on::before {
        background: #e4e9fe;
      }
    }

    .content-bottom {
      .content-overview {
        background: #171922;
        .overview-title {
          color: #fff;
        }
        .overview-today {
          background: #272935;
        }
        .overview-zf {
          color: #aab9d1;
        }
        .overview-text {
          color: #aab9d1;
        }
      }
      .content-stock {
        background: #171922;
        .stock-title {
          color: #fff;
        }
        .table-title {
          background-color: #171922 !important;
        }
        table {
          th {
            color: #6b7687;
          }
          td {
            color: #c9cbdc;
            &:first-child {
              p {
                &:first-child {
                  color: #c9cbdc !important;
                }
                &:last-child {
                  color: #6b7687 !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
